import {
  ISubmitAvailabilityPayload,
  QueryAvailabilityAdvancedPayload,
  QueryAvailabilityPayload,
  QueryAvailabilityResponse,
  RecordSessionPayload
} from "./types/availability.type";
import { baseUrlFunctions } from "./common";
import { axiosWithRetry } from "./utils/axiosRetry";

export const getAvailabilityData = async (
  requestPayload: QueryAvailabilityPayload
) => {
  const url = `${baseUrlFunctions}/queryAvailability/candidate/people`;
  try {
    const response = await axiosWithRetry<QueryAvailabilityResponse>(
      url,
      "post",
      {
        data: requestPayload,
        timeout: 120000
      }
    );
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error(error?.message);
    }
  }
};

export const getAvailabilityAdvancedData = async (
  requestPayload: QueryAvailabilityAdvancedPayload
) => {
  const url = `${baseUrlFunctions}/queryAvailability/candidate/people/advanced`;
  try {
    const response = await axiosWithRetry<QueryAvailabilityResponse>(
      url,
      "post",
      {
        data: requestPayload,
        // RoosterBlocks-only tag pools can take several minutes (RSTR-24694)
        timeout: 300000
      }
    );
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error(error?.message);
    }
  }
};

export const recordSession = async (
  payload: RecordSessionPayload
): Promise<void> => {
  const url = `${baseUrlFunctions}/queryAvailability/candidate/session`;
  try {
    await axiosWithRetry(url, "post", { data: payload, timeout: 5000 });
  } catch {
    // best-effort — never throw
  }
};

export const submitAvailabilityData = async (
  client: string,
  requestPayload: ISubmitAvailabilityPayload
) => {
  const url = `${baseUrlFunctions}/enqueue/proxy/${client}/availability/candidate`;
  try {
    const response = await axiosWithRetry<string>(url, "patch", {
      data: requestPayload,
      timeout: 120000
    });
    return response.data;
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error(error?.message);
    }
  }
};
